module.exports = __webpack_public_path__ + "static/media/profile-fonctionnaire.1edefc03.svg";